import SVGIconWrapper from "./SVGIconWrapper"

const IconClose = (props) => (
    <SVGIconWrapper
        fill={props.fill ?? "#000000"}
        style={props.style}
        viewBox="0 0 500 500"
        iconClass={`icon--close ${props.iconClass}`}
        wrapperClass={props.wrapperClass}
        onClick={props.onClick}
    >
        <path d="M.4 21.2L21.2.4l478.4 478.4-20.8 20.8zM20.8 500L0 479.2 479.2 0 500 20.8z" />
    </SVGIconWrapper>
)

export default IconClose